import ICouchsurfing from "../types/couchsurfing-type";
import api from "./auth-interceptor"

class CouchsurfingService {
  getAllCouchsurfings() {
    return api.get(`couchsurfing/`);
  }

  listCouchsurfing(couchsurfingContent: ICouchsurfing) {
    return api.post(`couchsurfing/`, couchsurfingContent);
  }

  getInfoById(listingId: string) {
    return api.get<ICouchsurfing>(`couchsurfing/${listingId}`);
  }

  updateCouchsurfing(couchsurfingId: string, couchsurfingContent: ICouchsurfing) {
    return api.put(`couchsurfing/${couchsurfingId}`, couchsurfingContent);
  }

  deleteListing(couchsurfingId: string) {
    return api.delete(`couchsurfing/${couchsurfingId}/`);
  }
}

const couchsurfingService = new CouchsurfingService();
export default couchsurfingService;
